/* Boxbait — theme scripts (vanilla, no dependencies) */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function formatMoney(cents, format) {
    var value = (cents / 100).toFixed(2);
    var parts = value.split('.');
    var withCommas = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + parts[1];
    format = format || '${{amount}}';
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (m, key) {
      if (key === 'amount_no_decimals') return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return withCommas;
    });
  }

  /* Same rounding as the Liquid templates: subtotal − round(subtotal × %) */
  function pctTotal(subtotal, pct) {
    return subtotal - Math.round(subtotal * (parseFloat(pct) || 0) / 100);
  }

  /* ---------- Reveal on scroll ---------- */
  function initReveal() {
    var els = document.querySelectorAll('.bb-reveal:not(.bb-visible)');
    if (!els.length) return;
    if (reduceMotion || !('IntersectionObserver' in window) || (window.Shopify && window.Shopify.designMode)) {
      els.forEach(function (el) { el.classList.add('bb-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('bb-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------- Lazy autoplay videos (hero, steps) ---------- */
  function initAutoVideos() {
    var vids = document.querySelectorAll('video[data-bb-autoplay]');
    if (!vids.length) return;
    if (!('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        var v = entry.target;
        if (entry.isIntersecting) {
          if (v.preload === 'none') v.preload = 'auto';
          if (!reduceMotion) { var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        } else {
          v.pause();
        }
      });
    }, { threshold: 0.2 });
    vids.forEach(function (v) { io.observe(v); });
  }

  /* ---------- UGC carousel ---------- */
  function initUgc(root) {
    (root || document).querySelectorAll('[data-bb-ugc]').forEach(function (wrap) {
      if (wrap.dataset.bbReady) return;
      wrap.dataset.bbReady = '1';
      var track = wrap.querySelector('.bb-ugc__track');
      wrap.querySelectorAll('[data-bb-ugc-arrow]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var card = track.querySelector('.bb-ugc__card');
          var step = card ? card.getBoundingClientRect().width + 16 : 260;
          track.scrollBy({ left: btn.dataset.bbUgcArrow === 'next' ? step : -step, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
      });
      wrap.querySelectorAll('.bb-ugc__card').forEach(function (card) {
        var video = card.querySelector('video');
        var play = card.querySelector('.bb-ugc__play');
        if (!video || !play) return;
        function toggle() {
          if (video.paused) {
            wrap.querySelectorAll('video').forEach(function (other) {
              if (other !== video) { other.pause(); other.closest('.bb-ugc__card').classList.remove('is-playing'); }
            });
            video.muted = false;
            video.play();
            card.classList.add('is-playing');
          } else {
            video.pause();
            card.classList.remove('is-playing');
          }
        }
        play.addEventListener('click', toggle);
        video.addEventListener('click', toggle);
        video.addEventListener('ended', function () { card.classList.remove('is-playing'); });
      });
    });
  }

  /* ---------- Announcement snow ---------- */
  function initSnow() {
    document.querySelectorAll('[data-bb-snow]').forEach(function (box) {
      if (box.childElementCount || reduceMotion) return;
      for (var i = 0; i < 26; i++) {
        var f = document.createElement('i');
        var size = 3 + Math.random() * 4;
        f.style.left = Math.random() * 100 + '%';
        f.style.width = f.style.height = size + 'px';
        f.style.animationDuration = 3 + Math.random() * 4 + 's';
        f.style.animationDelay = -Math.random() * 6 + 's';
        box.appendChild(f);
      }
    });
  }

  /* ---------- Delivery estimate ---------- */
  function addBusinessDays(date, days) {
    var d = new Date(date.getTime());
    var added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      var dow = d.getDay();
      if (dow !== 0 && dow !== 6) added++;
    }
    return d;
  }
  function initDelivery(root) {
    (root || document).querySelectorAll('[data-bb-delivery]').forEach(function (el) {
      var min = parseInt(el.dataset.min, 10) || 8;
      var max = parseInt(el.dataset.max, 10) || 15;
      var now = new Date();
      var opts = { month: 'short', day: 'numeric' };
      var from = addBusinessDays(now, min).toLocaleDateString('en-US', opts);
      var to = addBusinessDays(now, max).toLocaleDateString('en-US', opts);
      var out = el.querySelector('[data-bb-delivery-range]');
      if (out) out.textContent = from + ' – ' + to;
    });
  }

  function initTimeline(root) {
    (root || document).querySelectorAll('[data-bb-timeline]').forEach(function (el) {
      var now = new Date();
      var o = { month: 'short', day: 'numeric' };
      var calendar = el.dataset.mode === 'calendar';
      function d(n) {
        var x = calendar ? new Date(now.getTime() + n * 86400000) : addBusinessDays(now, n);
        return x.toLocaleDateString('en-US', o);
      }
      function range(a, b) { return a === b ? d(a) : d(a) + ' – ' + d(b); }
      var set = function (k, v) { var t = el.querySelector('[data-bb-tl="' + k + '"]'); if (t) t.textContent = v; };
      set('ordered', now.toLocaleDateString('en-US', o));
      set('ready', range(parseInt(el.dataset.readyMin, 10) || 1, parseInt(el.dataset.readyMax, 10) || 2));
      set('delivered', range(parseInt(el.dataset.delMin, 10) || 8, parseInt(el.dataset.delMax, 10) || 17));
    });
  }

  function initReviewSlider(root) {
    (root || document).querySelectorAll('[data-bb-rslider]').forEach(function (el) {
      if (el.dataset.bbReady) return;
      el.dataset.bbReady = '1';
      var track = el.querySelector('.bb-rslider__track');
      var dots = el.querySelectorAll('.bb-rslider__dot');
      var n = track.children.length, i = 0, timer;
      function go(k) { i = (k + n) % n; track.scrollTo({ left: track.clientWidth * i, behavior: reduceMotion ? 'auto' : 'smooth' }); mark(); }
      function mark() { dots.forEach(function (d, k) { d.classList.toggle('is-active', k === i); }); }
      dots.forEach(function (d, k) { d.addEventListener('click', function () { go(k); restart(); }); });
      track.addEventListener('scroll', function () { var k = Math.round(track.scrollLeft / track.clientWidth); if (k !== i) { i = k; mark(); } }, { passive: true });
      var secs = parseInt(el.dataset.interval, 10) || 0;
      function restart() { clearInterval(timer); if (secs > 0 && n > 1 && !reduceMotion) timer = setInterval(function () { go(i + 1); }, secs * 1000); }
      restart();
    });
  }

  /* ---------- Cart helpers ---------- */
  function getCartDrawer() { return document.querySelector('cart-drawer'); }

  function addItems(items) {
    var drawer = getCartDrawer();
    var body = { items: items };
    if (drawer) {
      body.sections = drawer.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) {
      return r.json().then(function (data) {
        if (!r.ok || data.status) throw new Error(data.description || data.message || 'Could not add to cart');
        return data;
      });
    }).then(function (data) {
      if (drawer) {
        drawer.classList.remove('is-empty');
        drawer.renderContents(data);
        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'bb-product', cartData: data });
        }
      } else {
        window.location.href = (window.routes && window.routes.cart_url) || '/cart';
      }
      return data;
    });
  }

  /* Cart drawer upsell buttons ("Add 2 more and save") */
  function initCartUpsell() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bb-upsell-add]');
      if (!btn) return;
      e.preventDefault();
      btn.disabled = true;
      addItems([{ id: parseInt(btn.dataset.variant, 10), quantity: parseInt(btn.dataset.qty, 10) || 1 }])
        .catch(function () { btn.disabled = false; });
    });
  }

  /* ---------- Product page ---------- */
  function initProduct(root) {
    (root || document).querySelectorAll('[data-bb-product]').forEach(function (section) {
      if (section.dataset.bbReady) return;
      section.dataset.bbReady = '1';

      var dataEl = section.querySelector('[data-bb-product-json]');
      if (!dataEl) return;
      var data = JSON.parse(dataEl.textContent);
      var variants = data.variants;
      var moneyFormat = data.money_format;
      var form = section.querySelector('form.bb-form');
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var atc = section.querySelector('[data-bb-atc]');
      var atcLabel = atc ? atc.querySelector('[data-bb-atc-label]') : null;
      var errorEl = section.querySelector('[data-bb-error]');
      var paymentWrap = section.querySelector('[data-bb-payment]');
      var current = variants.filter(function (v) { return v.id === data.selected; })[0] || variants[0];

      function getSelectedOptions() {
        var values = [];
        section.querySelectorAll('[data-bb-option]').forEach(function (fs) {
          var checked = fs.querySelector('input:checked');
          values[parseInt(fs.dataset.bbOption, 10)] = checked ? checked.value : null;
        });
        return values;
      }
      function findVariant(values) {
        return variants.filter(function (v) {
          return v.options.every(function (opt, i) { return values[i] == null || values[i] === opt; });
        })[0];
      }

      /* Pack selection */
      function getPack() {
        var checked = section.querySelector('[data-bb-pack] input:checked');
        if (!checked) return { qty: 1, total: null };
        var q = parseInt(checked.value, 10) || 1;
        var total = null;
        if (checked.dataset.total) total = parseInt(checked.dataset.total, 10);
        else if (checked.dataset.percent && current) total = pctTotal(current.price * q, checked.dataset.percent);
        return { qty: q, total: total, label: checked.dataset.label || '' };
      }

      function updatePrices() {
        var pack = getPack();
        var unit = current ? current.price : 0;
        var unitCompare = current && current.compare_at_price > unit ? current.compare_at_price : unit;
        var total = pack.total != null && pack.total > 0 ? pack.total : unit * pack.qty;
        var compare = unitCompare * pack.qty;
        var nowEl = section.querySelector('[data-bb-price-now]');
        var wasEl = section.querySelector('[data-bb-price-was]');
        var saveEl = section.querySelector('[data-bb-price-save]');
        if (nowEl) nowEl.textContent = formatMoney(total, moneyFormat);
        if (wasEl) { wasEl.textContent = compare > total ? formatMoney(compare, moneyFormat) : ''; wasEl.hidden = !(compare > total); }
        if (saveEl) {
          var pct = compare > total ? Math.round((1 - total / compare) * 100) : 0;
          saveEl.hidden = pct <= 0;
          saveEl.textContent = (saveEl.dataset.template || 'Save [percent]%').replace('[percent]', pct).replace('[amount]', formatMoney(compare - total, moneyFormat));
        }
        var totalEl = section.querySelector('[data-bb-total]');
        if (totalEl) totalEl.textContent = formatMoney(total, moneyFormat);
        document.querySelectorAll('[data-bb-sticky-price]').forEach(function (el) {
          el.textContent = (pack.qty > 1 && pack.label ? pack.label + ' · ' : '') + formatMoney(total, moneyFormat);
        });
        // Per-pack card prices follow the selected variant's compare-at price
        section.querySelectorAll('[data-bb-pack] input').forEach(function (inp) {
          var q = parseInt(inp.value, 10) || 1;
          var card = inp.nextElementSibling;
          var t = inp.dataset.total ? parseInt(inp.dataset.total, 10)
            : inp.dataset.percent ? pctTotal(unit * q, inp.dataset.percent) : unit * q;
          var priceEl = card.querySelector('.bb-qb__price');
          var c = card.querySelector('[data-bb-pack-compare]');
          if (c) c.textContent = unitCompare * q > t ? formatMoney(unitCompare * q, moneyFormat) : '';
          var s = card.querySelector('[data-bb-pack-save]');
          if (s) {
            var saving = unitCompare * q - t;
            s.textContent = saving > 0 ? (s.dataset.template || 'Save [amount]').replace('[amount]', formatMoney(saving, moneyFormat)) : '';
          }
          if (priceEl) priceEl.textContent = formatMoney(t, moneyFormat);
          var each = card.querySelector('[data-bb-pack-each]');
          if (each) each.textContent = formatMoney(Math.round(t / q), moneyFormat);
        });
      }

      function updateAvailability() {
        section.querySelectorAll('[data-bb-option]').forEach(function (fs) {
          var idx = parseInt(fs.dataset.bbOption, 10);
          var selected = getSelectedOptions();
          fs.querySelectorAll('input').forEach(function (inp) {
            var test = selected.slice();
            test[idx] = inp.value;
            var v = findVariant(test);
            var exact = v && v.options.every(function (o, i) { return test[i] == null || test[i] === o; });
            inp.parentElement.classList.toggle('is-unavailable', !(exact && v.available));
          });
          var label = fs.querySelector('[data-bb-option-value]');
          var checked = fs.querySelector('input:checked');
          if (label && checked) label.textContent = checked.value;
        });
      }

      function setVariant(v) {
        current = v;
        if (v) section.dataset.currentVariant = v.id;
        document.dispatchEvent(new CustomEvent('bb:variant-change', { detail: { variant: v, section: section } }));
        if (!atc) return;
        if (!v) {
          atc.disabled = true;
          if (atcLabel) atcLabel.textContent = atc.dataset.unavailable || 'Unavailable';
          return;
        }
        if (idInput) idInput.value = v.id;
        atc.disabled = !v.available;
        if (atcLabel) atcLabel.textContent = v.available ? atc.dataset.label : atc.dataset.soldout || 'Sold out';
        if (paymentWrap) paymentWrap.classList.toggle('bb-hidden-pay', !v.available);
        if (v.featured_media && window.innerWidth) {
          var gallery = section.querySelector('[data-bb-gallery]');
          if (gallery && gallery.bbGoTo) gallery.bbGoTo(v.featured_media);
        }
        if (data.update_url && window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
        updatePrices();
        updateAvailability();
      }

      section.addEventListener('change', function (e) {
        if (e.target.closest('[data-bb-option]')) {
          setVariant(findVariant(getSelectedOptions()));
        } else if (e.target.closest('[data-bb-pack]')) {
          var pack = getPack();
          if (qtyInput) qtyInput.value = pack.qty;
          buildMixRows();
          updatePrices();
        }
      });

      /* Bundle cards: one color picker per box inside the selected card */
      var unitsMode = !!section.querySelector('[data-bb-units-mode]');
      var unitIds = [];
      function variantById(id) { return variants.filter(function (x) { return String(x.id) === String(id); })[0]; }
      function swatchFor(v) {
        if (!v || !data.swatches) return '#ccc';
        var name = v.options[0];
        return data.swatches[name] || data.swatches[v.title] || String(name).toLowerCase();
      }
      function escapeHtml(t) { return String(t).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
      function mixEnabled() {
        if (!unitsMode) return false;
        return unitIds.some(function (id) { return String(id) !== String(unitIds[0]); });
      }
      function syncFromUnits() {
        var first = variantById(unitIds[0]) || current;
        current = first;
        if (first) {
          section.dataset.currentVariant = first.id;
          if (idInput) idInput.value = first.id;
          if (atc) {
            var allOk = unitIds.every(function (id) { var v = variantById(id); return v && v.available; });
            atc.disabled = !allOk;
            if (atcLabel) atcLabel.textContent = allOk ? atc.dataset.label : atc.dataset.soldout || 'Sold out';
          }
        }
        // Express checkout buys a single variant: hide it when boxes have different colors
        if (paymentWrap) paymentWrap.hidden = mixEnabled();
        document.dispatchEvent(new CustomEvent('bb:variant-change', { detail: { variant: first, section: section } }));
        updatePrices();
      }
      function buildUnits() {
        if (!unitsMode) return;
        var qty = getPack().qty;
        var fallback = unitIds[unitIds.length - 1] || (current && current.id);
        while (unitIds.length < qty) unitIds.push(fallback);
        unitIds.length = qty;
        section.querySelectorAll('[data-bb-units]').forEach(function (c) { c.innerHTML = ''; });
        var checked = section.querySelector('[data-bb-pack] input:checked');
        var box = checked && checked.nextElementSibling.querySelector('[data-bb-units]');
        if (!box || variants.length < 2) { syncFromUnits(); return; }
        var html = '<span class="bb-unit__label">' + escapeHtml(data.options[0] ? data.options[0].name : 'Color') + '</span>';
        for (var i = 0; i < qty; i++) {
          var v = variantById(unitIds[i]) || variants[0];
          html += '<span class="bb-unit" data-unit="' + i + '">' +
            (v.image ? '<img class="bb-unit__img" src="' + v.image + '" alt="" width="40" height="40" loading="lazy">' : '<span class="bb-unit__img"></span>') +
            '<span class="bb-unit__dot" style="--bb-sw:' + escapeHtml(swatchFor(v)) + '"></span>' +
            '<select aria-label="' + escapeHtml((data.box_label || 'Box') + ' ' + (i + 1)) + '">';
          variants.forEach(function (opt) {
            html += '<option value="' + opt.id + '"' + (String(opt.id) === String(v.id) ? ' selected' : '') + (opt.available ? '' : ' disabled') + '>' + escapeHtml(opt.title) + '</option>';
          });
          html += '</select></span>';
        }
        box.innerHTML = html;
        syncFromUnits();
      }
      section.addEventListener('change', function (e) {
        var unit = e.target.closest('.bb-unit');
        if (!unit) return;
        e.stopPropagation();
        var i = parseInt(unit.dataset.unit, 10);
        unitIds[i] = e.target.value;
        var v = variantById(e.target.value);
        var img = unit.querySelector('img.bb-unit__img');
        if (img && v && v.image) img.src = v.image;
        var dot = unit.querySelector('.bb-unit__dot');
        if (dot) dot.style.setProperty('--bb-sw', swatchFor(v));
        if (v && v.featured_media) {
          var g = section.querySelector('[data-bb-gallery]');
          if (g && g.bbGoTo) g.bbGoTo(v.featured_media);
        }
        syncFromUnits();
      }, true);
      function buildMixRows() { buildUnits(); }

      function collectItems() {
        var pack = getPack();
        if (!unitsMode) return [{ id: current.id, quantity: pack.qty }];
        var counts = {};
        var order = [];
        unitIds.forEach(function (id) {
          if (!counts[id]) { counts[id] = 0; order.push(id); }
          counts[id]++;
        });
        return order.map(function (id) { return { id: parseInt(id, 10), quantity: counts[id] }; });
      }

      if (form) {
        form.addEventListener('submit', function (e) {
          if (!window.fetch) return;
          e.preventDefault();
          if (!current || !current.available) return;
          var items = collectItems();
          if (errorEl) errorEl.hidden = true;
          if (!items) {
            if (errorEl) { errorEl.textContent = data.mix_error || 'One of the selected combinations is unavailable.'; errorEl.hidden = false; }
            return;
          }
          atc.classList.add('is-loading');
          atc.setAttribute('aria-busy', 'true');
          addItems(items).catch(function (err) {
            if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
          }).then(function () {
            atc.classList.remove('is-loading');
            atc.removeAttribute('aria-busy');
          });
        });
      }

      /* Gallery */
      var gallery = section.querySelector('[data-bb-gallery]');
      if (gallery) {
        var main = gallery.querySelector('.bb-gallery__main');
        var slides = Array.prototype.slice.call(gallery.querySelectorAll('.bb-gallery__slide'));
        var thumbs = gallery.querySelectorAll('.bb-gallery__thumb');
        var dots = gallery.querySelectorAll('.bb-gallery__dot');
        var active = 0;
        function mark(i) {
          active = i;
          thumbs.forEach(function (t, ti) { t.classList.toggle('is-active', ti === i); t.setAttribute('aria-current', ti === i ? 'true' : 'false'); });
          dots.forEach(function (d, di) { d.classList.toggle('is-active', di === i); });
          slides.forEach(function (s, si) {
            var v = s.querySelector('video');
            if (v && si !== i) v.pause();
          });
        }
        function go(i) {
          if (i < 0) i = slides.length - 1;
          if (i >= slides.length) i = 0;
          main.scrollTo({ left: slides[i].offsetLeft, behavior: reduceMotion ? 'auto' : 'smooth' });
          mark(i);
        }
        gallery.bbGoTo = function (mediaId) {
          var idx = slides.findIndex(function (s) { return String(s.dataset.mediaId) === String(mediaId); });
          if (idx > -1) go(idx);
        };
        thumbs.forEach(function (t, i) { t.addEventListener('click', function () { go(i); }); });
        dots.forEach(function (d, i) { d.addEventListener('click', function () { go(i); }); });
        var prev = gallery.querySelector('[data-bb-prev]');
        var next = gallery.querySelector('[data-bb-next]');
        if (prev) prev.addEventListener('click', function () { go(active - 1); });
        if (next) next.addEventListener('click', function () { go(active + 1); });
        var t;
        main.addEventListener('scroll', function () {
          clearTimeout(t);
          t = setTimeout(function () {
            var i = Math.round(main.scrollLeft / main.clientWidth);
            if (i !== active && slides[i]) mark(i);
          }, 80);
        }, { passive: true });
      }

      /* Sticky add to cart */
      var sticky = document.querySelector('[data-bb-sticky][data-section="' + section.dataset.section + '"]') || document.querySelector('[data-bb-sticky]');
      if (sticky && atc && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            var past = !entry.isIntersecting && entry.boundingClientRect.top < 0;
            sticky.classList.toggle('is-visible', past);
            sticky.setAttribute('aria-hidden', past ? 'false' : 'true');
          });
        });
        io.observe(atc);
        var ssel = sticky.querySelector('[data-bb-sticky-variant]');
        if (ssel) {
          ssel.addEventListener('change', function () { section.bbSelectVariant(ssel.value); });
          document.addEventListener('bb:variant-change', function (e) { if (e.detail.variant) ssel.value = e.detail.variant.id; });
        }
        var sbtn = sticky.querySelector('[data-bb-sticky-btn]');
        if (sbtn) {
          sbtn.addEventListener('click', function () {
            if (mixEnabled() || !current || !current.available) {
              form.scrollIntoView({ behavior: reduceMotion ? 'auto' : 'smooth', block: 'center' });
            }
            if (current && current.available) {
              if (form.requestSubmit) form.requestSubmit(atc); else atc.click();
            }
          });
        }
      }

      /* External controls (color showcase section) can select an option value */
      section.bbSelectOption = function (index, value) {
        if (unitsMode) {
          var match = variants.filter(function (x) { return x.options[parseInt(index, 10)] === value; })[0];
          if (match) section.bbSelectVariant(match.id);
          return;
        }
        var fs = section.querySelector('[data-bb-option="' + index + '"]');
        if (!fs) return;
        var inp = Array.prototype.find.call(fs.querySelectorAll('input'), function (i) { return i.value === value; });
        if (inp && !inp.checked) { inp.checked = true; setVariant(findVariant(getSelectedOptions())); }
      };
      section.bbSelectVariant = function (id) {
        var v = variants.filter(function (x) { return String(x.id) === String(id); })[0];
        if (!v) return;
        if (unitsMode) {
          unitIds = unitIds.map(function () { return v.id; });
          if (!unitIds.length) unitIds = [v.id];
          current = v;
          buildUnits();
          if (v.featured_media) { var g = section.querySelector('[data-bb-gallery]'); if (g && g.bbGoTo) g.bbGoTo(v.featured_media); }
          return;
        }
        v.options.forEach(function (val, i) {
          var fs = section.querySelector('[data-bb-option="' + i + '"]');
          if (!fs) return;
          Array.prototype.forEach.call(fs.querySelectorAll('input'), function (inp) { inp.checked = inp.value === val; });
        });
        setVariant(v);
      };
      section.bbSubmit = function () {
        if (form && current && current.available) { if (form.requestSubmit) form.requestSubmit(atc); else atc.click(); }
      };
      if (current) section.dataset.currentVariant = current.id;

      if (qtyInput) qtyInput.value = getPack().qty;
      buildMixRows();
      updatePrices();
      updateAvailability();
    });
  }

  /* Color showcase section: picks the color in the main buy box */
  function initColorShowcase(root) {
    (root || document).querySelectorAll('[data-bb-color-showcase]').forEach(function (list) {
      if (list.dataset.bbReady) return;
      list.dataset.bbReady = '1';
      var idx = list.dataset.optionIndex;
      var wrap = list.closest('section');
      function main() { return document.querySelector('[data-bb-product]'); }
      list.addEventListener('click', function (e) {
        var btn = e.target.closest('.bb-colors__btn');
        if (!btn) return;
        var m = main();
        if (m && m.bbSelectOption) m.bbSelectOption(idx, btn.dataset.value);
        list.querySelectorAll('.bb-colors__btn').forEach(function (b) {
          b.classList.toggle('is-active', b === btn);
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
      });
      document.addEventListener('bb:variant-change', function (e) {
        var v = e.detail.variant;
        if (!v) return;
        var val = v.options[parseInt(idx, 10)];
        list.querySelectorAll('.bb-colors__btn').forEach(function (b) {
          var on = b.dataset.value === val;
          b.classList.toggle('is-active', on);
          b.setAttribute('aria-pressed', on ? 'true' : 'false');
        });
      });
      var atcBtn = wrap && wrap.querySelector('[data-bb-color-atc]');
      if (atcBtn) atcBtn.addEventListener('click', function () {
        var m = main();
        if (m && m.bbSubmit) m.bbSubmit();
      });
    });
  }

  /* Bundle section: "Buy 2 / Buy 3" add that many of the color chosen in the buy box */
  function initBundles() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-bb-bundle-add]');
      if (!btn) return;
      var m = document.querySelector('[data-bb-product]');
      var bundle = btn.closest('[data-bb-bundle]');
      var id = (m && m.dataset.currentVariant) || (bundle && bundle.dataset.variant);
      if (!id) return;
      btn.classList.add('is-loading');
      addItems([{ id: parseInt(id, 10), quantity: parseInt(btn.dataset.bbBundleAdd, 10) || 1 }])
        .catch(function () {})
        .then(function () { btn.classList.remove('is-loading'); });
    });
  }

  /* Home pack cards / links with ?pack=N pre-select the pack on the product page */
  function initPackFromUrl() {
    var params = new URLSearchParams(window.location.search);
    var pack = params.get('pack');
    if (!pack) return;
    var input = document.querySelector('[data-bb-pack] input[value="' + parseInt(pack, 10) + '"]');
    if (input && !input.checked) {
      input.checked = true;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }

  function initAll(root) {
    initReveal();
    initAutoVideos();
    initUgc(root);
    initSnow();
    initDelivery(root);
    initTimeline(root);
    initReviewSlider(root);
    initProduct(root);
    initColorShowcase(root);
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll(document);
    initCartUpsell();
    initBundles();
    initPackFromUrl();
  });
  document.addEventListener('shopify:section:load', function (e) { initAll(e.target); });
})();
